import type React from 'react';

export function FilterWrapper({
  label,
  children,
  className = '',
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex flex-row items-center ${className}`}>
      <div className="text-sm font-medium text-gray-700 min-w-0 flex-shrink-0 w-24">{label}</div>
      <div className="flex-shrink-0 ml-4 flex-1">{children}</div>
    </div>
  );
}
